module.exports = __webpack_public_path__ + "static/media/CTBC-UX-5-designScreen.6b745473.png";